import { Avatar, Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  secondaryTitle?: string;
  typeName: string;
  logoUrl?: string;
}

const ObjectTitle = ({ title, secondaryTitle, typeName, logoUrl }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    {logoUrl && (
      <Avatar
        src={logoUrl}
        variant="rounded"
        alt="logo"
        slotProps={{ img: { sx: { objectFit: "contain" } } }}
        sx={{ width: 80, height: 32 }}
      />
    )}
    <Stack spacing={0.5}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "baseline" }}>
        <Typography variant="h6">{title}</Typography>
        {secondaryTitle && (
          <>
            <Typography>&bull;</Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {secondaryTitle}
            </Typography>
          </>
        )}
      </Stack>
      <Typography variant="caption" color="textSecondary">
        {typeName}
      </Typography>
    </Stack>
  </Stack>
);

export default ObjectTitle;
